import moment from 'moment';
export default {
  data: {
    batches: [],
    moment: moment
  },
  methods: {
    bindData(data) {
      console.log(data);
      this.batches = data.batches;
    },
    reRunTranscoding(batch) {
      console.log(batch);
      const job = batch.jobs[0];
      const route = Kadenze.Routes.re_run_transcoding_admin_transcode_jobs_path({job_id: job.id});

      const req = Kadenze.AjaxRequest({
        url: route,
        loadingIndicator: {
          container: this.$el
        }
      });

      req.done((data) => {
        console.log(data);
        if (data.success) {
          let { batches } = this;
          batches = _.without(batches, batch);
          this.batches = batches;
          Kadenze.Notice.success({
            title: 'Successfully re-ran transcoding'
          });
        } else {
          Kadenze.Notice.error({
            title: 'Sorry, we were unable to re-run transcoding for this video.'
          });
        }
      });
    }
  }
};
